import React, { useEffect, useState } from 'react'
import Box from '@mui/material/Box'
import { useDispatch, useSelector } from 'react-redux'
import { updateFilter, showFilter } from '../../../../../store/actions/filter.actions'
import { useLocation, useNavigate } from 'react-router-dom'
import isEmpty from 'lodash/isEmpty'
import { updateSkip } from '../../../../../store/actions/datatable.actions'
import DialogConfirmCancel from '../../../../dialog/DialogConfirm'
import FormLcElements from './FormLcElements'
import FormCurriculumElements from './FormCurriculumElements'
import { setChildrenData } from '../../utils'

const FilterDialog = () => {
  const navigate = useNavigate()
  const { pathname } = useLocation()

  const filter = useSelector(state => state?.filter.lc?.filter || {})
  const open = useSelector(state => state?.filter.lc?.open || false)

  const dispatch = useDispatch()

  const [form, setInputForm] = useState(filter)

  useEffect(() => {
    if (!isEmpty(filter)) {
      setInputForm(filter)
    }
  }, [filter])

  const onClose = () => {
    dispatch(showFilter('lc', false))
  }

  const onChange = (field, key, name, value = '') => {
    if (field === 'curriculumElements') {
      const formData = setChildrenData(form[field] || {}, key, value, true)
      setInputForm({ ...form,  [field]: formData })
    } else {
      const formData = form[field] || {};
      const formDataName = form[`${field}_name`] || {};
      if (formData) {
        if (value) {
          formData[key] = value
          formDataName[key] = {
            name, value
          }
        } else {
          delete formData[key]
          delete formDataName[key]
        }
      }
      setInputForm({ ...form,  [field]: formData, [`${field}_name`]: formDataName })
    }
  }

  const onApply = () => {
    onClose()
    const filter = {
      ...form
    }
    dispatch(updateFilter('lc', filter));
    dispatch(updateSkip('lc', 0));
    navigate(pathname, { state: filter });
  }

  return (
    <DialogConfirmCancel
      id='lc-filter'
      open={open} 
      title="Filter"
      maxWidth='xs'
      onCancel={onClose}
      onConfirm={onApply}
      textConfirm='Apply'
    >
      <Box className='grid grid-cols-4 gap-4'>
        <FormCurriculumElements
          form={form.curriculumElements}
          onChange={(key, name, value) => onChange('curriculumElements', key, name, value)}
        />
        <FormLcElements
          form={form.lcElements}
          onChange={(key, name, value) => onChange('lcElements', key, name, value)}
        />
      </Box>
    </DialogConfirmCancel>
  )
}

export default FilterDialog

